<template>
    <div class="mt-6 px-6">
        <h3 class="text-subheading font-semibold">
            {{ $t('itemModal.macroNutrients') }}
        </h3>

        <div class="mt-4 space-y-4">
            <div class="macro-item">
                <div class="flex justify-between items-center mb-2">
                    <span class="text-sm font-medium">{{
                        $t('itemModal.carbohydrates')
                    }}</span>
                    <span class="text-sm text-muted"
                        >{{ formattedTotalCarbs }}g</span
                    >
                </div>
                <div class="w-full h-2 bg-gray-200 rounded-sm">
                    <div
                        class="h-full bg-button rounded-sm transition-all duration-300"
                        :style="{ width: carbsPercentage + '%' }"
                    ></div>
                </div>
                <div class="text-xs text-muted mt-1"
                    >{{ carbsPercentage }}% of item total</div
                >
            </div>

            <div class="macro-item">
                <div class="flex justify-between items-center mb-2">
                    <span class="text-sm font-medium">{{
                        $t('itemModal.fats')
                    }}</span>
                    <span class="text-sm text-muted"
                        >{{ formattedTotalFats }}g</span
                    >
                </div>
                <div class="w-full h-2 bg-gray-200 rounded-sm">
                    <div
                        class="h-full bg-button rounded-sm transition-all duration-300"
                        :style="{ width: fatsPercentage + '%' }"
                    ></div>
                </div>
                <div class="text-xs text-muted mt-1"
                    >{{ fatsPercentage }}% of item total</div
                >
            </div>

            <div class="macro-item">
                <div class="flex justify-between items-center mb-2">
                    <span class="text-sm font-medium">{{
                        $t('itemModal.protein')
                    }}</span>
                    <span class="text-sm text-muted"
                        >{{ formattedTotalProtein }}g</span
                    >
                </div>
                <div class="w-full h-2 bg-gray-200 rounded-sm">
                    <div
                        class="h-full bg-button rounded-sm transition-all duration-300"
                        :style="{ width: proteinPercentage + '%' }"
                    ></div>
                </div>
                <div class="text-xs text-muted mt-1"
                    >{{ proteinPercentage }}% of item total</div
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MacroCalculator',
    props: {
        totalCarbs: {
            type: Number,
            default: 0
        },
        totalFats: {
            type: Number,
            default: 0
        },
        totalProtein: {
            type: Number,
            default: 0
        }
    },
    computed: {
        totalMacros() {
            return this.totalCarbs + this.totalFats + this.totalProtein;
        },
        formattedTotalCarbs() {
            if (this.totalCarbs === 0) return 0;
            return this.totalCarbs.toFixed(1);
        },
        formattedTotalFats() {
            if (this.totalFats === 0) return 0;
            return this.totalFats.toFixed(1);
        },
        formattedTotalProtein() {
            if (this.totalProtein === 0) return 0;
            return this.totalProtein.toFixed(1);
        },
        carbsPercentage() {
            if (this.totalMacros === 0) return 0;
            return ((this.totalCarbs / this.totalMacros) * 100).toFixed(0);
        },
        fatsPercentage() {
            if (this.totalMacros === 0) return 0;
            return ((this.totalFats / this.totalMacros) * 100).toFixed(0);
        },
        proteinPercentage() {
            if (this.totalMacros === 0) return 0;
            return ((this.totalProtein / this.totalMacros) * 100).toFixed(0);
        }
    }
};
</script>
